<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="420">
    <v-card>
        <v-toolbar class="mid-font" dense elevation="1" >
            <v-icon left >mdi-account-cash-outline</v-icon><span class="va-underline">Confirm Payment</span>
            <v-spacer/>
            <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
          </v-toolbar>
        <v-card-text>
             <v-form
                ref="form"
                class="mt-4"
                v-model="valid"
                lazy-validation
              >
              <v-row>
                         <v-col cols="12">
                                <div class="text-center text-h4 font-weight-bold">{{$money(AMOUNTOPAY)}}</div>
                                <p class="text-center">Amount To Pay</p>
                         </v-col>
                <v-col cols="12">
                         <v-autocomplete
                        v-model="method"
                        :rules="textRules"
                        hide-details
                      required
                        :items="methods"
                        outlined
                          dense
                        label="Payment Method"
                        ></v-autocomplete> 
                </v-col>
               <v-col cols="12">
                    <v-text-field
                  v-model="methodref"
                    label="Referrence (Optional)"
                    outlined
                     hide-details
                    dense
                  required
                  ></v-text-field>
                 </v-col> 
                
              </v-row>
             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">Confirm And Paid</v-btn>
        </v-card-actions>
    </v-card>
  
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    data: {
       type: Object,
        default: ()=>{}
    },

    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      menu: false,
      s3upload: false,
      date:"",
      newpassword:'',
      show1: false,
      item: {},
      imgsrc:"",
      imgview:false,
      selected_account:{},
      method: '',
      methods:[''],
      methodref:"",
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      AMOUNTOPAY(){
         if(this.data.type=='Installment' || this.data.type=='Rental') {
            return this.data.init_payment
          } else {
            return this.data.total_amount
          }
      }
  },
  watch: {
    show (v) {
      if (v) {
       this.methods = this.GET_SYSVARS('payment_methods')
       this.method = ""
       this.methodref = ''
      } 
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
           this.Update()
        }
      },
     
      Update() {
          var sales = this.data
          var status = sales.status
          if(this.data.type=='Standard') {
            status = "Completed"
          }
          if(this.data.type=='Installment') {
            status = "Active"
          }
          if(this.data.type=='Rental') {
            status = "In Progress"
          }

          sales.payment_method = this.method
          sales.payment_status = "Paid"
          sales.payment_ref = this.methodref
          sales.status = status

        this.$http.post("update_sales", sales).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 3000)
            this.emitToParent('confirmed')
          
        }).catch(e => {
          console.log(e.data)
        })
     },
   
    emitToParent (action) {
        this.$emit('DialogEvent', action)
    }
  }
}
</script>
